<mat-form-field>
  <mat-label>Sysselsättning</mat-label>
  <mat-select #input="ngModel" [(ngModel)]="model"
              placeholder="Välj i listan..." required>
    <mat-option [value]="null" disabled>Välj i listan...</mat-option>
    @for (item of occupations() | keyvalue: sortOriginal; track $index) {
      <mat-option
        [value]="item.key">{{ item.value }}
      </mat-option>
    }

  </mat-select>

  @if (input.errors) {
    <mat-error>Vänligen kontrollera fältet</mat-error>
  }

  @if (input.errors && input.touched) {
    <mat-icon matIconSuffix aria-hidden="true">
      priority_high
    </mat-icon>
  }
</mat-form-field>